module.exports = __webpack_public_path__ + "static/media/login-background.bbcd520e.png";